import React from 'react';

function DashboardCardBlock({ children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', alignItems: 'flex-start' }}>{children}</div>
  );
}

export default DashboardCardBlock;
